import './css/index.css';
import '../text-block-full-width-accordion';